import { defineQuery } from 'next-sanity'

export const locationListBlockFields = `
  _id,
  _type,
  title,
  type,
  "additionalContactCards": additionalContactCards[]->{
    _id,
    _type,
    title,
    address
  }
`

export const LOCATION_LIST_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "location-list-block"][0]{
    ${locationListBlockFields}
  }
`)
